import clsx from "clsx";

import { useStyles } from "./Timeline.styles";


export interface TickProps {
    label?: string;
    offset: number;
    major?: boolean;
}

export const Tick: React.FC<TickProps> = ({ label, offset, major }) => {
    const classes = useStyles();

    return (
        <span
            className={clsx(classes.tick, major ? classes.tickMajor : classes.tickMinor)}
            style={{ left: `${offset}%` }}
        >
            {label ? <div>{label}</div> : null}
        </span>
    );
};
